import { useRef, useMemo, useState, useEffect } from 'react';
import qs from 'qs';
const useParams = () => {
    const updateQs = useRef(false);
    const { q, page, sort, ...filters } = useMemo(() => {
        // eslint-disable-next-line no-shadow
        const { q, page, sort, ...filters } = qs.parse(window.location.search, {
            ignoreQueryPrefix: true
        });
        Object.keys(filters).forEach(filter => {
            if (typeof filters[filter] === 'string') {
                filters[filter] = [filters[filter]];
            }
        });
        return { q, page, sort, ...filters };
    }, []);
    const [params, setParams] = useState({
        q: (q && q.toString()) || '',
        page: page || 1,
        sort: sort && sort.toString(),
        filters
    });
    useEffect(() => {
        const buildQueryString = () => {
            const qsParams = {};
            if (params.q) {
                qsParams.q = params.q;
            }
            if (params.sort) {
                qsParams.sort = params.sort;
            }
            if (params.filters) {
                Object.keys(params.filters).forEach(key => {
                    qsParams[key] = params.filters[key];
                });
            }
            const qsValue = qs.stringify(qsParams, {
                encode: false,
                encodeValuesOnly: true,
                arrayFormat: 'repeat'
            });
            const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${qsValue ? `?${qsValue}` : ''}`;
            window.history.pushState({}, '', newUrl);
        };
        if (updateQs.current) {
            buildQueryString();
        }
        else {
            updateQs.current = true;
        }
    }, [params]);
    useEffect(() => {
        const handlePopState = () => {
            const qsParams = qs.parse(window.location.search, {
                ignoreQueryPrefix: true
            });
            updateQs.current = false;
            // eslint-disable-next-line no-shadow
            const { q: _q, page: _page, sort: _sort, ...rest } = qsParams;
            Object.keys(rest).forEach(filter => {
                if (typeof rest[filter] === 'string') {
                    rest[filter] = [rest[filter]];
                }
            });
            setParams({
                q: _q || '',
                page: _page || 1,
                sort: _sort,
                filters: rest
            });
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);
    const setQuery = (qu) => {
        setParams({ ...params, q: qu, page: 1 });
    };
    const setPage = (p) => {
        setParams({ ...params, page: p });
    };
    const setSort = (s) => {
        setParams({ ...params, sort: s, page: 1 });
    };
    const setFilters = (f) => {
        setParams({ ...params, filters: f });
    };
    const setTag = (t) => {
        // Leaving this here in case client wants to keep filters active when switching tag from a result card
        // setParams({ ...params, filters: { ...params.filters, tag: t }, page: 1 });
        setParams({ ...params, filters: { tag: t }, page: 1 });
    };
    return [params, setQuery, setPage, setSort, setFilters, setTag];
};
export default useParams;
